import { initializeApp } from 'https://www.gstatic.com/firebasejs/11.1.0/firebase-app.js';
import {
  getMessaging,
  getToken
} from 'https://www.gstatic.com/firebasejs/11.1.0/firebase-messaging.js';

const storageKey = 'WebPush:sentToServer';

function isTokenSentToServer(token) {
  return window.sessionStorage.getItem(storageKey) === token;
}

function setTokenSentToServer(token) {
  window.sessionStorage.setItem(storageKey, token);
}

const app = initializeApp(window.firebaseConfig);
const messaging = getMessaging(app);
const getTokenOption = { vapidKey: window.firebaseVapidKey };

function sendToken(currentToken) {
  const csrfToken = $('meta[name="csrf-token"]').attr('content');
  if (!csrfToken || !currentToken) {
    return $.Deferred().reject().promise();
  }

  // Send token to the server
  return $.post('/webpush', {
    _csrf: csrfToken,
    token: currentToken
  });
}

// Initializer

const webPushAction = 'WebPush';
function sendGA(action, label) {
  if (window.tom.helper && window.tom.helper.ga) {
    window.tom.helper.ga.push(['event', 'EC', action, label, 1]);
  }
}

function init() {
  return getToken(messaging, getTokenOption)
    .then(function (currentToken) {
      if (isTokenSentToServer(currentToken)) {
        return;
      }

      return sendToken(currentToken).then(function () {
        sendGA(webPushAction, 'on');
        setTokenSentToServer(currentToken);
      });
    })
    .catch(function (err) {
      if (err.code === 'messaging/permission-blocked') {
        if (isTokenSentToServer('')) {
          return;
        }

        sendGA(webPushAction, 'off');
        setTokenSentToServer('');
      }
    });
}

init();
